import * as CONSTANTS from '../../constants';

export default {

    /**
     * Indicates that the activity is loading.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_PENDING] (state) {
        state.activity = {...state.activity, loading: true, error: false, noContent: false, items: undefined};
    },

    /**
     * Indicates that the activity is fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_SUCCESS] (state, payload) {
        state.activity = {...state.activity, loading: false, error: false, noContent: false, items: payload};
    },

    /**
     * Indicates that the activity is failed.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_FAILURE] (state) {
        state.activity = {...state.activity, loading: false, error: true, noContent: false, items: undefined};
    },

    /**
     * Indicates that the activity has no content.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_NO_CONTENT] (state) {
        state.activity = {...state.activity, loading: false, error: false, noContent: true, items: undefined};
    },

    /**
     * Indicates that the activity is loading.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATIONS_PENDING] (state) {
        state.notifications = {...state.notifications, loading: true, error: false, noContent: false, items: undefined};
    },

    /**
     * Indicates that the activity is fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_NOTIFICATIONS_SUCCESS] (state, payload) {
        state.notifications = {...state.notifications, loading: false, error: false, noContent: false, item: {...{}, ...payload}, originalItem: {...{}, ...payload}};
    },

    /**
     * Indicates that the activity is failed.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATIONS_FAILURE] (state) {
        state.notifications = {...state.notifications, loading: false, error: true, noContent: false, items: undefined};
    },

    /**
     * Indicates that the activity has no content.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATIONS_NO_CONTENT] (state) {
        state.notifications = {...state.notifications, loading: false, error: false, noContent: true, items: undefined};
    },

    /**
     * Set the number of rows displayed in the activity list.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_ROWS_SET] (state, payload) {
        state.activity.limit = payload;
    },

    /**
     * Increment the activity list page.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_PAGE_INCREMENT] (state) {
        state.activity.page++;
    },

    /**
     * Decrement the activity list page.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_PAGE_DECREMENT] (state) {
        state.activity.page--;
    },

    /**
     * Reset the activity list page.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_ACTIVITY_PAGE_RESET] (state) {
        state.activity.page = 1;
    },

    /**
     * Indicates that the notification toggle is pending.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_PENDING] (state) {
        state.notifications = {...state.notifications, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the notification toggle was successful.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_SUCCESS] (state, payload) {
        state.notifications = {...state.notifications, loading: false, error: false, noContent: false, item: {...{}, ...payload.data}, originalItem: {...{}, ...payload.data}};
    },

    /**
     * Indicates that the notification toggle failed.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_TOGGLE_FAILURE] (state) {
        state.notifications = {...state.notifications, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the notifications levels are being updated.
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_PENDING] (state) {
        state.notifications = {...state.notifications, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the notifications update was successful.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_SUCCESS] (state, payload) {
        if(payload.admin) {
            state.notifications = {...state.notifications, loading: false, error: false, noContent: false, admin: {...{}, ...payload.data}, original: {...{}, ...payload.data}};
        } else {
            state.notifications = {...state.notifications, loading: false, error: false, noContent: false};
            state.notifications.items[payload.id] = payload.data;
        }
    },

    /**
     * Indicates that the notification update feiled.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_FAILURE] (state) {
        state.notifications = {...state.notifications, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that no notification levels was updated.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_UPDATE_NO_CONTENT] (state) {
        state.notifications = {...state.notifications, loading: false, error: false, noContent: true};
    },

    /**
     * Updates the notification object.
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_EDIT] (state, payload) {
        if(payload.item.hasOwnProperty('days')) {
            state.notifications.item.days = {...state.notifications.item.days, ...payload.item.days}
        } else {
            state.notifications.item = {...state.notifications.item, ...payload.item};
        }
    },

    /**
     * Toggle the notifications edit mode.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_NOTIFICATION_EDIT_TOGGLE] (state, payload) {
        if(payload) {
            state.notifications.editMode = payload;
        } else {
            state.notifications.editMode = !state.notifications.editMode;
        }
    },

    /**
     * Edit the user object.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_USER_EDIT] (state, payload) {
        state.user.user = {...state.user.user, ...payload};
    },

    /**
     * Reset the user object.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_USER_RESET] (state) {
        state.user.user = state.user.originalUser;
    },

    /**
     * Indicates that the user is pending.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_USER_PENDING] (state) {
        state.user = {...state.user, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the user was successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_USER_SUCCESS] (state, payload) {
        state.user = {...state.user, loading: false, error: false, noContent: false, user: {...{}, ...payload}, originalUser: {...{}, ...payload}};
    },

    /**
     * Indicates that the user fetch failed.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_USER_FAILURE] (state) {
        state.user = {...state.user, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the user returned no content.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_USER_NO_CONTENT] (state) {
        state.user = {...state.user, loading: false, error: false, noContent: true};
    },

    /**
     * Indicates that the user update is pending.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_USER_UPDATE_PENDING] (state) {
        state.user = {...state.user, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the user update was successful.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_USER_UPDATE_SUCCESS] (state, payload) {
        state.user = {...state.user, loading: false, error: false, noContent: false};
        state.user.user = {...state.user.user, ...{...{}, ...payload.data}};
        state.user.originalUser = {...state.user.originalUser, ...{...{}, ...payload.data}};
    },

    /**
     * Indicates that the user update failed.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_USER_UPDATE_FAILURE] (state) {
        state.user = {...state.user, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the user update returned no content.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_USER_UPDATE_NO_CONTENT] (state) {
        state.user = {...state.user, loading: false, error: false, noContent: true};
    },

    /**
     * Edit the password objects.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ACCOUNT_PASSWORD_EDIT] (state, payload) {
        state.password = {...state.password, ...payload};
    },

    /**
     * Reset the new password objects.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_PASSWORD_RESET] (state) {
        state.password = {...state.password, password: '', newPassword: '', retypePassword: ''};
    },

    /**
     * Indicates that the password update is pending.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_PASSWORD_UPDATE_PENDING] (state) {
        state.password = {...state.password, loading: true, error: false, noContent: false};
    },

    /**
     * Indicates that the password update was successful.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_PASSWORD_UPDATE_SUCCESS] (state) {
        state.password = {...state.password, loading: false, error: false, noContent: false};
    },

    /**
     * Indicates that the password update failed.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_PASSWORD_UPDATE_FAILURE] (state) {
        state.password = {...state.password, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the password update returned no content.
     *
     * @param state
     */
    [CONSTANTS.ACCOUNT_PASSWORD_UPDATE_NO_CONTENT] (state) {
        state.password = {...state.password, loading: false, error: false, noContent: true};
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/account/mutations.js